/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import autobind from 'class-autobind';

type SortDetails = {
  oldIndex: number;
  newIndex: number;
};

type Props = {
  items: Array<React.ReactNode>;
  onSort?: (oldIndex: number, newIndex: number) => void;
  onSortEnd?: (
    details: SortDetails,
    event: {
      [key: string]: any;
    },
  ) => void;
};

export default class SortableComponent extends Component<Props> {
  constructor(props: Props) {
    super(props);
    autobind(this);
  }

  render() {
    let { items, ...otherProps } = this.props;
    return (
      <SortableList
        {...otherProps}
        items={items}
        onSortEnd={this._onSortEnd}
        distance={1}
        lockAxis="y"
      />
    );
  }

  _onSortEnd(
    details: SortDetails,
    event: {
      [key: string]: any;
    },
  ) {
    let { onSortEnd, onSort } = this.props;
    if (onSortEnd) {
      onSortEnd(details, event);
    }
    if (onSort) {
      let { oldIndex, newIndex } = details;
      if (oldIndex !== newIndex) {
        onSort(oldIndex, newIndex);
      }
    }
  }
}

let SortableList = SortableContainer((props: any) => {
  let { items, onSort, ...otherProps } = props;
  let children = items.map((item: any, index: number) => (
    <SortableItem key={item.key} index={index} value={item} />
  ));
  return <div {...otherProps}>{children}</div>;
});

let SortableItem = SortableElement((props: any) => props.value);
